import React from 'react';
import { formatAvailableDate } from '@/data/foods';

interface AvailableDateBadgeProps {
    date: Date;
    label?: string;
}

const AvailableDateBadge: React.FC<AvailableDateBadgeProps> = ({ date, label }) => {
    const formatted = formatAvailableDate(date, "Aujourd'hui", 'Demain', '\u00C0 partir du');

    return (
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 text-xs font-semibold border border-emerald-200 dark:border-emerald-800">
            <span className="text-sm">📅</span>
            {label && <span>{label}</span>}
            <span>{formatted}</span>
        </div>
    );
};

export default AvailableDateBadge;
